import React from 'react';

import Table from 'components/Table';
import useClassUsage from 'hooks/reports/utilization/class-usage/useClassUsage';

import columns from './columns';
import useOrdering from './ordering';
import { ClassUsageSearchFilters } from '../../SearchFilters';

const ClassUsageTable = ({ searchFilters }: { searchFilters: ClassUsageSearchFilters }): JSX.Element => {
  const { data, isError, isLoading, isSuccess } = useClassUsage(searchFilters);
  const { ordering, ascending, handleHeaderClick, sortedData } = useOrdering({ data });

  return (
    <>
      <Table
        tableData={sortedData}
        columns={columns}
        isSuccess={isSuccess}
        isLoading={isLoading}
        isError={isError}
        isFetchingNextPage={false}
        hasNextPage={false}
        handleHeaderClick={handleHeaderClick}
        ordering={ordering}
        ascending={ascending}
        clickableHeaders={[
          'classTypeName',
          'weekday',
          'startTime',
          'coachFullName',
          'totalSessions',
          'availableSpots',
          'reservedSpots',
          'averageAttendace',
          'attended',
          'noShows',
          'lateCancels',
          'utilizationRate',
          'changePercentage',
        ]}
      />
    </>
  );
};

export default ClassUsageTable;
